import MicrophoneStrikethroughIcon from '@atlaskit/icon-lab/core/microphone-strikethrough';
import * as React from 'react';

export function SvgMicOff() {
  return <MicrophoneStrikethroughIcon label="" testId="ads-refreshed-icon" />;
}
